import { combineReducers } from 'redux';
import clientDetails from './clientDetails';
import clientsList from './clientsList';
import clientsRecentList from './clientsRecentList';
import cart from './cart';
import checkout from './checkout';
import orderHistory from './orderHistory';
import orderDetails from './orderDetails';
import resendReceipt from './resendReceipt';
import groups from './groups';
import prePopulatedGroups from './prePopulatedGroups';
import loyalty from './loyalty';
import reasonToContact from './reasonToContact';
import reminders from './reminders';
import clientPurchaseInsights from './clientPurchaseInsights';
import clientOnlineBagTab from './clientOnlineBagTab';
import wishlist from './wishlist';

const appReducer = combineReducers({
  clientsList,
  clientsRecentList,
  clientDetails,
  cart,
  checkout,
  orderHistory,
  orderDetails,
  resendReceipt,
  groups,
  prePopulatedGroups,
  loyalty,
  reasonToContact,
  reminders,
  clientPurchaseInsights,
  clientOnlineBagTab,
  wishlist,
});

export default (state, action) => appReducer(state, action);
